import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import Empty from 'antd/lib/empty';
import Row from 'antd/lib/row';
import { useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import Card from 'antd/lib/card/Card';
import { theme } from 'antd/lib';
import Typography from 'antd/lib/typography';
import { EnergyEventDto, EnergyUsageTimeseriesDto } from '../../../../domain/energy/interface';
import { BaselineMode } from '../../../../domain/energy/baselineMarket';
import { IDateRange } from '../../../interface';
import { EnergyHeatMapChart } from './EnergyHeatMapChart';
import { SECONDARY_COLOR } from '../../../../theme';

interface IEnergyUsageOverHourWidget {
    dateRange: IDateRange;
    energyData: EnergyUsageTimeseriesDto; // aggregate
    eventsData: EnergyEventDto[]; // aggregate
    /** which baseline/performance to render based on the selected sites' markets; 'none' hides them */
    baselineMode: BaselineMode;
}

export const EnergyUsageOverHourWidget = ({ energyData, eventsData, dateRange, baselineMode }: IEnergyUsageOverHourWidget) => {
    const { token: themeColors } = theme.useToken();

    const [showMore, setShowMore] = useState(false);
    const toggleShowMore = () => setShowMore(!showMore);

    const isDataExist = Boolean(energyData?.values?.length);

    return (
        <Card style={{ marginBottom: '16px' }} className="energy-usage-widget">
            <Typography.Title level={4} style={{ marginTop: 0, color: SECONDARY_COLOR }}>
                Energy Usage Over Each Hour
            </Typography.Title>
            {isDataExist ? (
                <>
                    <Row gutter={[0, 0]}>
                        <Col xs={24} className={`energy-usage-chart ${showMore && 'energy-usage-chart-expanded'}`}>
                            <EnergyHeatMapChart energyData={energyData} eventsData={eventsData} dateRange={dateRange} baselineMode={baselineMode} />
                        </Col>
                    </Row>
                    <Row gutter={[0, 0]}>
                        <Col xs={24} style={{ textAlign: 'center', paddingTop: '8px' }}>
                            <Button onClick={toggleShowMore} type="link">
                                <Typography.Text strong style={{ fontSize: '16px', color: themeColors.colorPrimary }}>
                                    {showMore ? (
                                        <>
                                            Show less <UpOutlined />
                                        </>
                                    ) : (
                                        <>
                                            Show more <DownOutlined />
                                        </>
                                    )}
                                </Typography.Text>
                            </Button>
                        </Col>
                    </Row>
                </>
            ) : (
                <Row gutter={[0, 0]}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </Col>
                </Row>
            )}
        </Card>
    );
};
